import React from 'react'
import { cartStyles as styles } from './navbar.tailwind'
import { ShoppingCart } from '@mui/icons-material'
import routeConstant from '../../lib/constants/routeConstant'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Cart = ({ disableCart }) => {
  const navigate = useNavigate();
  const { totalCount } = useSelector(state => state.cart)

  {/* Shopping Cart */}
  return (
    <button className={styles.container} onClick={() => navigate(routeConstant.CART_PAGE)} disabled={disableCart}>
      <ShoppingCart className={styles.carticon} />
      {/* Current Cart Count */}
      {totalCount > 0 && (<span className={styles.total_count_badge}>{totalCount}</span>)}
    </button>
  )
}

export default Cart